import { useState, useEffect } from "react";
import { CardContainer, CardHeader, CardBody, BestSelect } from "best-common-react";
import { useAuth } from "../../contexts/AuthContext";
import RosterThresholdsSettings from "./rosterThresholds/RosterThresholdsSettings";
import CardSettings from "./card/CardSettings";
import DefaultLineupSettings from "./lineup/DefaultLineupSettings";
import UsersTable from "./users/UsersTable";
import { AuthConstants } from "../../constants/AuthConstants";

export const SETTINGS_CONFIG = [
  {
    title: "Card Settings",
    component: CardSettings,
    visible: ({ isAdmin }) => isAdmin(),
  },
  {
    title: "Default Lineup",
    component: DefaultLineupSettings,
    visible: ({ hasRole }) => !hasRole(AuthConstants.ROLES.AFL_ADMIN) && !hasRole(AuthConstants.ROLES.WBC_ADMIN),
  },
  {
    title: "Roster Thresholds",
    component: RosterThresholdsSettings,
    visible: ({ hasRole }) => hasRole(AuthConstants.ROLES.ADMIN),
  },
  {
    title: "Users",
    component: UsersTable,
    visible: ({ hasRole }) => hasRole(AuthConstants.ROLES.ADMIN),
  },
];

const SettingsComponent = () => {
  const { hasRole, isAdmin } = useAuth();

  const visibleSettings = SETTINGS_CONFIG.filter((setting) => setting.visible({ hasRole, isAdmin }));

  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    if (selectedIndex >= visibleSettings.length && visibleSettings.length > 0) {
      setSelectedIndex(0);
    }
  }, [visibleSettings.length, selectedIndex]);

  const selectedSetting = visibleSettings[selectedIndex] || visibleSettings[0];
  const SettingComponent = selectedSetting?.component;

  const options = visibleSettings.map((setting) => ({
    value: setting.title,
    label: setting.title,
  }));

  if (visibleSettings.length === 0) {
    return (
      <CardContainer>
        <CardHeader>Settings</CardHeader>
        <CardBody>You don&apos;t have access to any settings.</CardBody>
      </CardContainer>
    );
  }

  return (
    <>
      <div className="mb-3" style={{ width: "200px" }}>
        <BestSelect
          options={options}
          placeHolder="Select setting"
          value={options[selectedIndex]}
          onChange={(option) => {
            const index = options.findIndex((o) => o.value === option?.value);
            if (index >= 0) setSelectedIndex(index);
          }}
          styles={{
            container: {
              height: "36px",
              fontSize: "14px",
            },
            control: {
              height: "36px",
              minHeight: "32px",
            },
            valueContainer: {
              padding: "0 8px 0px 8px",
            },
          }}
          onClick={() => {}}
        />
      </div>
      <CardContainer>
        <CardHeader>{selectedSetting?.title}</CardHeader>
        <CardBody>
          <SettingComponent />
        </CardBody>
      </CardContainer>
    </>
  );
};

export default SettingsComponent;
